// Keyboard logic of the header search (desktop dropdown and mobile overlay), after the WAI-ARIA
// combobox pattern: focus stays in the text field and aria-activedescendant points at the
// option the arrows reached. The results used to be plain buttons after the field: arrows did
// nothing, Enter did nothing, Escape did nothing, and a screen reader was never told a list had
// appeared.
//
// What one key does, given the active option (-1: none) and how many options there are.
// Returns {active, action} or null when the key is not the combobox's (Home/End with no option
// active move the caret in the text, as they should).
//   move    another option became active
//   select  Enter on the active option
//   submit  Enter with no option active (the caller opens /buscar)
//   close   Escape
export function comboboxKey(key, active, count) {
  switch (key) {
    case 'ArrowDown':
      if (!count) return null;
      return { active: active < count - 1 ? active + 1 : 0, action: 'move' };
    case 'ArrowUp':
      if (!count) return null;
      return { active: active > 0 ? active - 1 : count - 1, action: 'move' };
    case 'Home':
      if (!count || active < 0) return null;
      return { active: 0, action: 'move' };
    case 'End':
      if (!count || active < 0) return null;
      return { active: count - 1, action: 'move' };
    case 'Enter':
      return active >= 0 && active < count ? { active, action: 'select' } : { active: -1, action: 'submit' };
    case 'Escape':
      return { active: -1, action: 'close' };
    default:
      return null;
  }
}

// The URL of the full results page for a query.
export function searchPageUrl(q) {
  return `/buscar?q=${encodeURIComponent((q || '').trim())}`;
}
